module.exports = __webpack_public_path__ + "img/bg.33f31277.png";